
export default {
    setCompetencia(state, data) {
        state.competencia = data
    },
    setCompetencias(state, data) {
        state.competencias = data
    }
}